import styled from 'styled-components';

const PageTitle = styled.h2`
  text-align: center;
  font-size: 2em;
`;

export default PageTitle;
